module.exports = __webpack_public_path__ + "static/po-main-banner-image-bd914f25accec7e7f4d345f0feac6836.png";